const iconEdit = `
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
          <path d="M0 0h20v20H0z"/>
          <g fill-rule="nonzero" fill="#7A8E96">
              <path d="M14.667 10a.666.666 0 0 0-.667.666V16a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 16V6.666C3.333 6.3 3.632 6 4 6h5.333a.666.666 0 1 0 0-1.334H4c-1.103 0-2 .898-2 2V16c0 1.103.897 2 2 2h9.333c1.103 0 2-.897 2-2v-5.334a.666.666 0 0 0-.666-.666z"/>
              <path d="M8.25 9.392a.338.338 0 0 0-.09.17l-.472 2.358a.334.334 0 0 0 .393.392l2.356-.472a.332.332 0 0 0 .171-.09l5.275-5.276-2.357-2.356-5.275 5.274zM17.512 2.488a1.668 1.668 0 0 0-2.357 0l-.922.922 2.356 2.357.923-.923c.315-.314.488-.732.488-1.178 0-.445-.173-.864-.488-1.178z"/>
          </g>
      </g>
  </svg>
`

export default iconEdit
